var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list',{staticClass:"pa-0"},_vm._l((_vm.getTenantIds),function(tenantId){return _c('v-list-item',{key:tenantId,attrs:{"disabled":tenantId === _vm.getTenantId},on:{"click":function($event){return _vm.selecionarTenant(tenantId)}}},[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(_vm.$t(`sistema.${tenantId}`)))])],1)],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }